function showNextStep(step) {

    if (![1, 2, 3, 4].includes(step))
        return;

    $('.steps__wrapper').addClass('__active');
    setTimeout(function () {

        if (step == 3) {
            $('.modal.calc').removeClass('calc');
        }

        $('.step.active').removeClass('active');
        $('#step' + step).addClass('active');
        setTimeout(function () {
            $('.steps__wrapper').removeClass('__active');
        }, 200);
    }, 200);
}

